<template>
  <div>
    <right-panel class="float-right" id="sidebar-info-data-category" width="800px" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5" v-if="infoItem">
        <h3 class="mb-5">
          <i class="bx bx-info-circle align-middle font-size-24 mr-2"></i>
          <span class="  text-primary">{{ infoItem.name | translate }}</span>

          {{ $t("data-category.info") }}
        </h3>

        <content-loading v-if="isInfoLoading" />
        <div v-else>
          <div v-if="info.docs.length > 0">
            <h5 class="mt-2">{{ $t("data-category.special-quality-data") }}</h5>
            {{ info.docs[0].category.specialQualityData ? $t("common.yes") : $t("common.no") }}
            <h5 class="mt-4">{{ $t("data-category.personal-data") }}</h5>
            {{ info.docs[0].category.personalData ? $t("common.yes") : $t("common.no") }}
            <h5 class="mt-4">{{ $t("data-category.risk-effect-value") }}</h5>
            {{ info.docs[0].category.riskEffectValue }}
          </div>

          <h5 class="mt-4">{{ $t("data-category.used-places") }}</h5>
          <table v-if="info && info.docs.length > 0" class="table table-border table-striped">
            <thead class="bg-dark text-white">
              <tr>
                <th>{{ $t("department.text") }}</th>
                <th>{{ $t("process.text") }}</th>
                <th>{{ $t("datasource.text") }}</th>
                <th>{{ $t("data.text") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="i in info.docs" :key="'info' + i._id">
                <td>
                  {{ i.department.name | translate }}
                </td>
                <td>
                  {{ i.process.name | translate }}
                </td>
                <td>
                  {{ i.datasource.name | translate }}
                </td>
                <td>{{ i.name | translate }}</td>
              </tr>
            </tbody>
          </table>
          <empty v-else width="200px">
            <h6 class="text-center">{{ $t("common.no-hierarchy") }}</h6>
          </empty>
        </div>
        <div v-if="info" class="row">
          <div class="col ">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="infoRequest.options.page" :total-rows="info.totalDocs" :per-page="info.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </right-panel>

    <h2>{{ $t("data-category.organization-data-categories") }}</h2>

    <nav class="breadcrumb">
      <a class="breadcrumb-item" href="/organization">
        {{ $t("organization.text") }}
      </a>

      <a class="breadcrumb-item" href="/department">
        {{ $t("department.text") }}
      </a>

      <a class="breadcrumb-item text-muted" href="javascript:;">
        {{ $t("data-category.text") }}
      </a>
    </nav>

    <table class="table project-list-table table-centered table-borderless compact ">
      <tr>
        <th scope="col" style="width:300px">
          <sortable-table-head field="name" :text="$t('data-category.text')" tag="span" :request="request" />
        </th>

        <th scope="col" style="width: 15%">
          <a href="javascript:;" @click="toggleFilter">
            <span v-if="filterEnabled" class="text-warning">
              <i class="bx bxs-filter-alt"></i>
              {{ $t("common.filters-hide") }}
            </span>
            <span v-else class="text-muted">
              <i class="bx bxs-filter-alt"></i>
              {{ $t("common.filters-show") }}
            </span>
          </a>
        </th>
      </tr>

      <tr v-if="filterEnabled">
        <th><input class="form-control " v-model="nameFilter" /></th>

        <th></th>
      </tr>
    </table>

    <div v-if="pagination" class="row">
      <div class="col-2 hider font-small" v-for="item in pagination.docs" :key="item._id" @click="fetchInfo(item)" v-b-toggle="'sidebar-info-data-category'" v-b-tooltip.hover>
        <div class="card text-center p-2" v-bind:class="{ 'bg-success': item.completed }">
          <div>
            <div class="mt-2 text-truncate hand">
              <h6 v-b-tooltip.hover :title="$options.filters.translate(item.name)">
                {{ item.name | translate }}
              </h6>
            </div>
          </div>
          <div v-if="hasUpdatePermission || hasRemovePermission" class="hidden">
            <div class="d-flex mt-3 team-social-links">
              <div v-if="hasViewPermission" class="flex-fill">
                <a @click="fetchInfo(item)" v-b-toggle="'sidebar-info-data-category'" v-b-tooltip.hover :title="$t('common.info')">
                  <i class="bx bx-info-circle text-muted" style="visibility: hidden;"></i>
                  <!-- i simgesi kaldırılınca card boyutları değişmesin diye kullanıldı :D -->
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->

    <content-loading v-if="isLoading" />

    <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)">
      <h5 class="text-center">
        {{ $t("data-category.no-data-category") }}
      </h5>
    </empty>

    <!-- Begin: Pagination -->

    <div v-if="pagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      request: {
        options: { page: 1, limit: 15, sort: { name: "asc" } },
        query: {},
      },
      infoRequest: {
        options: { page: 1, limit: 5, sort: { name: "asc" } },
        query: {},
      },
      nameFilter: undefined,
      categoryFilter: undefined,
      filterEnabled: false,
    };
  },
  computed: {
    selectedEntity() {
      return this.$store.getters["organizationDataCategory/selectedEntity"];
    },
    pagination() {
      return this.$store.getters["organizationDataCategory/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationDataCategory/isLoading"];
    },
    infoItem() {
      return this.$store.getters["organizationDataCategory/infoItem"];
    },
    info() {
      return this.$store.getters["organizationDataCategory/info"];
    },
    isInfoLoading() {
      return this.$store.getters["organizationDataCategory/isInfoLoading"];
    },
    hasViewPermission() {
      return true;
    },
    hasUpdatePermission() {
      return true;
    },

    hasRemovePermission() {
      return true;
    },
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.paginate();
      },
    },
    infoRequest: {
      deep: true,
      immediate: false,
      handler() {
        this.debounce(() => this.fetchInfo());
      },
    },
    nameFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
  },
  mounted() {},
  methods: {
    async paginate() {
      await this.$store.dispatch("organizationDataCategory/paginate", this.request);
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationDataCategory/delete", item._id);

        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' Silindi");

        this.paginate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: "'" + this.$options.filters.translate(item.name) + "' Silinemedi" });
      }
    },

    fetchInfo(item) {
      if (!item) {
        item = this.infoItem;
      }
      this.$store.dispatch("organizationDataCategory/fetchInfo", { item, pagination: this.infoRequest });
    },

    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;

      if (!this.filterEnabled) {
        this.request = {
          options: { page: 1, limit: 15, sort: { name: "asc" } },
          query: {},
        };
        this.nameFilter = undefined;
        this.categoryFilter = undefined;
      }
    },

    rightPanelClosed() {
      this.paginate();
      this.$store.dispatch("organizationDataCategory/resetForm");
    },
  },
};
</script>
